/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pause': {
    width: 9,
    height: 17,
    viewBox: '0 0 9 17',
    data: '<g _stroke="#FFF" _fill="none" fill-rule="evenodd"><path pid="0" d="M.5.5v16-16zM8.5.5v16-16z"/></g>'
  }
})
